import IncidentPage from "@/app/(app)/(crew)/home/[shift]/incident";

export default IncidentPage;
